import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";
import { setActiveOrder, setNoOrderAvailable } from "./order.js";

import Logger from "../../common/util/Logger.js";
import { getApi } from "../../common/actions/net.js";
import { getExistingProductImage } from "./productImage.js";
import moment from "moment";

export const LOADING_LAST_DELIVERY = "LOADING_LAST_DELIVERY";
export const SET_LAST_DELIVERY = "SET_LAST_DELIVERY";
export const SET_LAST_DELIVERY_PRODUCT_IMAGE_URL = "SET_LAST_DELIVERY_PRODUCT_IMAGE_URL";
export const LOADING_NEXT_DELIVERY = "LOADING_NEXT_DELIVERY";
export const SET_UPCOMING_DELIVERY_DATES = "SET_UPCOMING_DELIVERY_DATES";
export const SET_NEXT_DELIVERY = "SET_NEXT_DELIVERY";
export const SET_NEXT_DELIVERY_ORDER_PRODUCT_IMAGE_URL = "SET_NEXT_DELIVERY_ORDER_PRODUCT_IMAGE_URL";
export const SET_NEXT_DELIVERY_UNCONFIRMED_ORDER_PRODUCT_IMAGE_URL = "SET_NEXT_DELIVERY_UNCONFIRMED_ORDER_PRODUCT_IMAGE_URL";

export const RESET_LAST_DELIVERY = "RESET_LAST_DELIVERY";

const setDeliveryDates = (deliveryDates) => ({
    type: SET_UPCOMING_DELIVERY_DATES,
    deliveryDates
});

const setNextDelivery = (delivery) => ({
    type: SET_NEXT_DELIVERY,
    delivery
});
/**
 * Loads last delivery, with information
 * @returns {func}
 */
export function getLastDelivery(){
    return async (dispatch, getState) => {
        try {
            //only one loading session
            if( getState().delivery.lastDelivery.loading ){
                return;
            }
            dispatch({
                type: LOADING_LAST_DELIVERY,
                loading: true,
            });
            //collect info regarding the campaign
            const {payload} = await dispatch(getApi("Order/GetLastDeliveryForCustomer"));

            if (!payload) {
                dispatch({
                    type: RESET_LAST_DELIVERY
                });
                return;
            }

            //insert existing images
            for(let i=0; i<payload.orderLines.length; i++){
                payload.orderLines[i].product.imageUrl = getExistingProductImage(payload.orderLines[i].productId);
            }
            //sotore the data
            await dispatch({
                type: SET_LAST_DELIVERY,
                delivery: payload,
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av leveringsinfo mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_LAST_DELIVERY,
                loading: false,
            });
        }
    };
}

/**
 * Loads next delivery, with information
 * @returns {func}
 */
export function getNextDelivery(){
    return async (dispatch, getState) => {
        try {
            //only one loading session
            if( getState().delivery.nextDelivery.loading ){
                return;
            }
            dispatch({
                type: LOADING_NEXT_DELIVERY,
                loading: true,
            });
            //collect info regarding the campaign
            const {payload} = await dispatch(getApi("Order/GetNextDeliveryForCustomer"));
            if( payload ){
                //insert existing images (orderLines)
                if( payload.orderLines ){
                    for(let i=0; i<payload.orderLines.length; i++){
                        if( payload.orderLines[i].product ){
                            payload.orderLines[i].product.imageUrl = getExistingProductImage(payload.orderLines[i].product.productId);
                        }
                    }
                }
                //insert existing images (unConfirmedOrderLines)
                if( payload.unConfirmedOrderLines ){
                    for(let i=0; i<payload.unConfirmedOrderLines.length; i++){
                        if( payload.unConfirmedOrderLines[i].product ) {
                            payload.unConfirmedOrderLines[i].product.imageUrl = getExistingProductImage(payload.unConfirmedOrderLines[i].product.productId);
                        }
                    }
                }
                //store data
                await dispatch( setNextDelivery(payload) );
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av leveringsinfo mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_NEXT_DELIVERY,
                loading: false,
            });
        }
    };
}

/**
 * return the next 4 upcoming delivery dates
 * @returns {func}
 */
export function botstrapDeliveryAndOrder(){
    return async (dispatch) => {
        try {
            const now = moment();

            const data = {
                fromDate: now.format("YYYY-MM-DD"),
                toDate: now.add(1, "M").format("YYYY-MM-DD"),
            };
            //collect info regarding the campaign
            const payload = await dispatch(getApi("Order/DeliveryDatesForPeriodQuery", data));
            if( payload.message==="OK") {
                //store to redux
                dispatch( setDeliveryDates(payload.payload) );
            }

            //get the order that we will be working on
            const nextOrder = payload.payload;//do we recive the data (test if this fail, to insert the data into the array)
            if( nextOrder.length>0 ) {
                dispatch( setActiveOrder(nextOrder[0].shipmentId, nextOrder[0].distributionRouteId, nextOrder[0].deliveryDate) );
            } else {
                setNoOrderAvailable();
            }

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lastning mislyktes", messageType.error));
            Logger.error(error);
            setNoOrderAvailable();
        }
    };
}

/**
 * return the next 4 upcoming delivery dates
 * @returns {func}
 */
export function getDeliveries(){
    return async (dispatch) => {
        try {
            const now = moment();

            const data = {
                fromDate: now.format("YYYY-MM-DD"),
                toDate: now.add(1, "M").format("YYYY-MM-DD"),
            };
            //collect info regarding the campaign
            const payload = await dispatch(getApi("Order/DeliveryDatesForPeriodQuery", data));
            if( payload.message==="OK") {
                //store to redux
                dispatch( setDeliveryDates(payload.payload) );
            }

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lastning mislyktes", messageType.error));
            Logger.error(error);
            setNoOrderAvailable();
        }
    };
}